import { Fragment } from "react";
import { useStaticImages } from "../../../hooks/useStaticImages";
import { useTranslation } from "react-i18next";
import BagGreen from "../../../assets/svg2/SVG Bags from Egzonarifi.svg";

export const AddedBaggageSection = ({ baggageList }) => {

  const { t } = useTranslation();
  const { luggage, suitcase } = useStaticImages();
    
   function returnBaggageCalc(bagg){
      let price=bagg.ancillary.baggagePrice
      price=Number(price + (price * 10) / 100).toFixed(2);
      const [firstPrice, secondPrice] = Number(price)?.toFixed(2)
      ?.toString()
      ?.split(".") || [];
      return{
        firstPrice,secondPrice
      }
    };

    function returnImageCondition(string=''){
      let finString='';
      for (let i = 0; i <= string.length; i++) {
         
        if(!isNaN(Number(string.charAt(i)))){
          finString+=''+string.charAt(i) 
        } 
        
      } 
      return Number(finString)<=20
    }
  
  return (
    <Fragment>
      {/* Always-included personal item */}
      <div className="itemdetail">
        <img
          src={BagGreen}
          alt="personal item"
          style={{ width: 32, height: 32, marginRight: 8, verticalAlign: "middle" }}
        />
        {t("personal_baggage", "Personal item")} <span style={{ marginLeft: 4 }}>{t("free", "Free")}</span>
      </div>

      {baggageList.map((baggage) => (
        <div class="itemdetail">
          
          {returnImageCondition(baggage.ancillary.baggageWeight) ? (
            <img
              srcSet={suitcase}
              alt="suitcase"
              style={{ width: 32, height: 32, marginRight: 8, verticalAlign: 'middle' }}
            />
          ) : (
            <img
              srcSet={luggage}
              alt="luggage"
              style={{ width: 32, height: 32, marginRight: 8, verticalAlign: 'middle' }}
            />
          )}
           
         
          {String(baggage.ancillary.baggageWeight).toLocaleLowerCase()}{" "}
          
          <span>
          {returnBaggageCalc(baggage).firstPrice}
                    <sup>{returnBaggageCalc(baggage).secondPrice || ""}</sup>{baggage.ancillary.baggageCurrency}
          </span>
        </div>
      ))}
    </Fragment>
  );
};
